import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';
import { GlobalDataService } from '../shared/services/global-data.service';
import { TenantModel } from '../core/models/tenant';
import { AppInitService } from '../app-init.service';
import { map } from 'rxjs/operators';
import { BusyService } from '../core/services/busy.service';
@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {
  username: string = "";
  constructor(
    private router: Router,
    private oauthService: OAuthService,
    private appInitService: AppInitService,
    private globalDataService: GlobalDataService,
    private spinner: BusyService) {
    // Here the term switch code is equal to the term ticket number
    // Purpose of this value is : When an eligible user is requesting tenant change
    // if the requesting tenant is not the default tenant, user should provide a ticket number
    // The oidc library we have used for authentication requests new token when page reloads
    // Hence we persist the parameters in the localstorage and retrieve it in the next refresh
    // const tenant: TenantModel = JSON.parse(localStorage.getItem('tenant'));
    // const switchCode = localStorage.getItem('switch_code');
    // if ( tenant && (tenant.isDefault || (tenant.tenantID && switchCode))) {
    //   this.oauthService.configure({... authConfig, customQueryParams: {tenant: tenant.tenantID, switchcode: switchCode} });
    //   localStorage.removeItem('tenant_id');
    //   localStorage.removeItem('tenant');
    //   localStorage.removeItem('switch_code');
    // }
    // let jwkhandler: JwksValidationHandler;
    // this.oauthService.tokenValidationHandler = jwkhandler;

  }


  ngOnInit() {
    
  }

  private _configurreAuthLibrary(): Promise<any>{
    return this.appInitService.getAppConfiguration$().pipe(
      map(appConfig => {
        issuer: appConfig.authentication.issuer
        redirectUri: appConfig.authentication.redirectUri
        clientId: appConfig.authentication.clientId
        scope: appConfig.authentication.clientscope
        strictDiscoveryDocumentValidation: appConfig.authentication.strictDiscoveryDocumentValidation
        responseType: appConfig.authentication.responseType
        showDebugInformation: appConfig.authentication.showDebugInformation
        postLogoutRedirectUri: appConfig.authentication.postLogoutRedirectUri
        logoutUrl: appConfig.authentication.logoutUrl
        allowedUrls: appConfig.authentication.allowedUrls
      })
    ).toPromise()
  }

  private _intiateAuthentiacation(authConfig: AuthConfig) {
    let tenant: TenantModel | null = null;
    const persistedTenant = localStorage.getItem('tenant');
    const switchCode = localStorage.getItem('switch_code');

    if (persistedTenant != null) {
      tenant = JSON.parse(persistedTenant);
    }
    
    if ( tenant && (tenant.isDefault || (tenant.tenantID && switchCode))) {
      this.oauthService.configure({ ...authConfig, customQueryParams: {tenant: tenant.tenantID, switchcode: switchCode} });
      localStorage.removeItem('tenant_id');
      localStorage.removeItem('tenant');
      localStorage.removeItem('switch_code');
    }

    this.oauthService.loadDiscoveryDocumentAndLogin().then(() => {
      if (this.oauthService.hasValidAccessToken()) {
        this.spinner.idle();
        this.globalDataService.setAccessToken(this.oauthService.getAccessToken());
        this.globalDataService.setIdToken(this.oauthService.getIdToken());
        this.router.navigate(['/dashboard/dashboard-landing']);
      } else {
        this.spinner.busy();
      }
    });
  }
}
